import { createAsyncThunk } from '@reduxjs/toolkit';
import Oidc from 'oidc-client';

const config = {
    authority: process.env.REACT_APP_AUTHORITY,
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    response_type: 'code',
    scope: 'openid profile email Myma.Api offline_access',
    post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
};

export const authSignIn = async () => {
    const auth = await new Oidc.UserManager(config);
    auth.signinRedirect();
};

export const authLogout = async () => {
    const auth = await new Oidc.UserManager(config);
    auth.signoutRedirect();
};

export const authCallback = createAsyncThunk('auth/authCallback', async () => {
    const response = await new Oidc.UserManager({
        response_mode: 'query',
    }).signinRedirectCallback();

    return JSON.stringify(response);
});
